export default [

  {
    path: "/messages/list",
    name: "messages-list",
    component: () => import("@/views/message/messages-list/messagesList.vue"),
    meta: {
      action: "read",
      resource: "messages",
    },
  },
  {
    path: "/message/edit/:id",
    name: "message-edit",
    component: () => import("@/views/message/message-edit/messageEdit.vue"),
    meta: {
      action: "update",
      resource: "messages",
    },
  },
  {
    path: "/message/create",
    name: "message-create",
    component: () => import("@/views/message/message-edit/messageEdit.vue"),
    meta: {
      action: "create",
      resource: "messages",
    },
  }
]